import Head from "next/head";
import dynamic from "next/dynamic";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";

const ShowcaseLayout = dynamic(() => import("../js/Components/Showcase/ShowcaseLayout"));

//Dynamically load the home component and return it
const videos = ({ data }) => {
    return (
        <>
            <Head>
                <title>{`Video Gallery - Page ${data.showcase.current_page} - ${process.env.brand.brand_name}`}</title>
                <meta
                    name="description"
                    content={`${process.env.brand.brand_name} offer furniture hire and chair rental throughout the UK. Our product range includes chairs to hire, conference furniture tables to hire, exhibition furniture hire, and office furntiture hire`}
                />
            </Head>
            <ShowcaseLayout {...data} />
        </>
    );
};

export async function getServerSideProps({ req, res, query }) {
    const exactSlug = query.slug;
    let exactRoute = query.route;
    let per_page = query?.per_page ? '&per_page=' + query.per_page : '';
    const { headers } = getClientIp(req);

    try {
        const page = !query.page ? 1 : query.page;
        const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}showcase?type=videos&page=${page}${per_page}`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.status == 'failed' || data?.exception) {
            return { notFound: true }
        }

        res.setHeader(
            'Cache-Control',
            'public, s-maxage=43200, stale-while-revalidate=59'
        );

        return {
            props: {
                data
            }
        };

    } catch (error) {
        return {
            props: {}
        }
    }
}
export default videos;
